<template>
  <div>
    <v-app-bar
      app
      color="green"
      dark
    >
      <v-app-bar-nav-icon v-if="isManager" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <text>asd</text>
      <v-menu
          bottom
          rounded
          left
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              x-large
              v-on="on"
            >
              <v-avatar
                color="accent shrink"
                size="40"
              >
                <span class="white--text text-h5">ASD</span>
              </v-avatar>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content class="justify-center">
              <div class="mx-auto text-center">
                <p class="text-caption mt-1">
                </p>
                <v-divider class="my-3"></v-divider>
                <v-btn
                  depressed
                  rounded
                  text
                >
                  Настройки
                </v-btn>
                <v-divider class="my-3"></v-divider>
                <v-btn
                  depressed
                  rounded
                  text
                  @click="logout"
                >
                  Выйти
                </v-btn>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
    </v-app-bar>
    <v-system-bar>
      <v-spacer></v-spacer>
    </v-system-bar>

    <v-navigation-drawer
      v-if="isManager"
      v-model="drawer"
      app
    >
      <v-sheet
        v-if="isManager"
        color="green"
        class="pa-4 text-center"
      >
        <v-avatar
          class="mb-4"
          color="accent shrink white--text"
          size="64"
        >
          <span class="white--text text-h3 text-capitalize">ASD</span>
        </v-avatar>
      </v-sheet>

      <v-divider></v-divider>

      <v-list v-if="isManager">
        <v-list-item-group
          mandatory
          color="indigo"
          exact
        >
          <template v-slot:default="item">
            <h1>{{ item }}</h1>
          </template>
          <template v-for="(item, key) in links">
            <v-list-item v-if="item.name"
              :key="key"
              @click="$router.push({ name: item.name }).catch(()=>{})"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="item.label"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-else
              color="indigo"
              :key="key"
              :prepend-icon="item.icon"
              no-action
              :value="true"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="item.label"></v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="child in item.items"
                :key="child.label"
                @click="$router.push({ name: child.name }).catch(()=>{})"
              >
                <v-list-item-icon>
                  <v-icon>
                    {{ child.icon }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="child.label"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>


        </v-list-item-group>
      </v-list>

    </v-navigation-drawer>

    <v-main>
      <router-view v-if="isManager"></router-view>
      <Cabinet v-else/>
    </v-main>
  </div>
</template>

<script>
import Cabinet from "../components/cabinet/Cabinet.vue"
export default {
  name: 'Home',
  props: {
    user: Object
  },
  components: {Cabinet},
  data: () => ({
    links: [
      {'icon': 'mdi-order-bool-descending-variant', 'label': 'Сотрудники', 'name': 'Employees'},
      {'icon': 'mdi-food-variant', 'label': 'Торговые предприятия', 'name': 'Departments'},
    ],
    drawer: null,
    model: 1,
  }),
  mounted() {
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/login')
      })
    },
  },
  computed: {
    isManager: function () {
      return this.$store.getters.isManager;
    }
  }
};
</script>
